import BaseServiceHttp from '../baseService'
class Editoras extends BaseServiceHttp {
  constructor(id) {
    const resource = 'editoras'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new Editoras(id)
